import {
  IPF_NETWORK_VIEWER,
  type NodeId,
  type NodeRecord,
} from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { array, record } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';

export const addExpandedHiddenNodes =
  (nodes: NodeRecord, oldNodes?: NodeRecord) =>
  (hiddenNodes: Set<NodeId>): Set<NodeId> => {
    if (!oldNodes) {
      return hiddenNodes;
    }

    const expandedHiddenNodeIds: Set<NodeId> = new Set(hiddenNodes);

    const hiddenPaths = pipe(
      oldNodes,
      record.filter(
        ({ parentPath, id }) =>
          parentPath === IPF_NETWORK_VIEWER && hiddenNodes.has(id),
      ),
      record.map(prop('path')),
      Object.values,
    );

    for (const path of hiddenPaths) {
      pipe(
        nodes,
        Object.values,
        array.filter((node) => node.parentPath === path),
        array.map(prop('id')),
        (ids) => {
          for (const id of ids) {
            expandedHiddenNodeIds.add(id);
          }
        },
      );
    }

    return expandedHiddenNodeIds;
  };
